// Checks if the input is a valid API key consisting only of digits (with optional negative sign)
const isApiKey = apiKey => /^-?\d+$/.test(apiKey);

export default isApiKey;
